import { events } from './event-bus'

let dispatchEvent = function (name, binding, vnode) {
  let options = {}
  try {
    options = vnode.data.attrs.options
  } catch (e) { }

  events.emit('app/' + binding.arg.replace(new RegExp('-', 'g'), '_') + '/' + name, {
    item: binding.value,
    options
  })
}

export default {
  install (Vue) {
    Vue.directive('create', {
      params: ['options'],
      bind (el, binding, vnode) {
        el.addEventListener('click', (el.event = () => {
          dispatchEvent('create', binding, vnode)
        }))
      },
      update (el, binding, vnode) {
        el.removeEventListener('click', el.event)
        el.addEventListener('click', el.event = () => {
          dispatchEvent('create', binding, vnode)
        })
      }
    })

    Vue.directive('edit', {
      params: ['options'],
      bind (el, binding, vnode) {
        el.addEventListener('click', el.event = () => {
          dispatchEvent('edit', binding, vnode)
        })
      },
      update (el, binding, vnode) {
        el.removeEventListener('click', el.event)
        el.addEventListener('click', el.event = () => {
          dispatchEvent('edit', binding, vnode)
        })
      }
    })

    Vue.directive('delete', {
      params: ['options'],
      bind (el, binding, vnode) {
        el.addEventListener('click', el.event = () => {
          dispatchEvent('delete', binding, vnode)
        })
      },
      update (el, binding, vnode) {
        el.removeEventListener('click', el.event)
        el.addEventListener('click', el.event = () => {
          dispatchEvent('delete', binding, vnode)
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/utils/directives.js